import { useContext } from "react";

import { LearningContext } from "../common/learning/LearningContext";

/**
 * Learning progress and Football IQ awards for the signed-in user.
 *
 * @returns {{
 *   progress: object,
 *   learnedIds: string[],
 *   learnedCount: number,
 *   loading: boolean,
 *   isLearned: (conceptId: string) => boolean,
 *   markLearned: (conceptId: string, source?: string) => Promise<object>,
 *   answerQuiz: (question: object, answerId: string) => Promise<object>,
 *   lastAward: object|null,
 *   clearLastAward: () => void,
 * }}
 */
export default function useLearning() {
  const context = useContext(LearningContext);
  if (!context) {
    throw new Error("useLearning must be used inside <LearningProvider>");
  }
  return context;
}
